export default {
  overview: {
    title: "Maschinen Übersicht",
    archive_title: "Archivierte Maschinen",
    subtitle: "Auflistung aller Maschinen.",
    actions: {
      create_new: "Neue Maschine erstellen",
    },
    search: {
      placeholder: "bspw. Name",
    },
    table: {
      headers: {
        id: "ID",
        name: "Bezeichnung",
        unit: "Abrechnungseinheit",
        purchasePrice: "Einkaufspreis",
        createdAt: "Erstellt am",
      },
      empty: {
        purchasePrice: "Nicht gesetzt",
      },
    },
  },
  // Verkaufseinheit einer Maschine beim Kunden bzw. im Projekt (LewMachineSellingUnitSelect).
  selling_unit: {
    label: "Verkaufseinheit",
    hint_variable: "Beim Aufschlag gilt die Einheit der Maschine",
    same_as_machine: "Wie Maschine",
  },
  detail: {
    title: "Maschine Details",
    actions: {
      update: "Speichern",
    },
    tabs: {
      general: "Allgemein",
      files: "Dateiablage",
      activity: "Protokoll",
    },
    form: {
      name: "Name",
      unit: "Abrechnungseinheit",
      purchasePrice: "Einkaufspreis",
      purchaseUnit: "Einkaufspreis Einheit",
      note: "Notizen",
      sections: {
        base_data: "Stammdaten",
        purchase: "Einkauf",
        note: "Notiz",
      },
    },
  },
  create: {
    title: "Maschine Anlegen",
    subtitle: "Neue Maschine anlegen.",
  },
  component: {
    autocomplete: {
      noDataText: "Maschine nicht gefunden {value}",
    },
  },
}
